import React, { FunctionComponent } from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions, Typography } from "@mui/material/";
import { GridColDef, GridColumnHeaderParams, GridRenderCellParams } from "@mui/x-data-grid";
import { CustomDataGrid } from "../../CustomDataGrid";
import { ChangeRow } from "../types";
import { formatDateHyphen, isValidDate } from "../../../utils/time";

const defaultColumnOptions = {
    resizable: false,
    flex: 1,
    hideSortIcons: false,
    disableColumnMenu: false,
}

const columns: GridColDef[] = [
    {
        field: "fieldName",
        headerName: "Field Name",
        headerAlign: "center",
        align: "center",
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                    {params.colDef.headerName!}
                </Typography>
            );
        },
        ...defaultColumnOptions
    },
    {
        field: "old",
        headerName: "Previous Value",
        headerAlign: "center",
        align: "center",
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                    {params.colDef.headerName!}
                </Typography>
            );
        },
        renderCell: (params: GridRenderCellParams) => {
            if ((params.row.fieldName as string).includes("Date")) {
                return (
                    <Typography>
                        { params.value === null ? "n/a" : formatDateHyphen(new Date(params.value)) }
                    </Typography>
                )
            }

            return (
                <Typography>
                    {((params.value === null) || (params.value === "")) ? "n/a" : params.value}
                </Typography>
            )
        },
        ...defaultColumnOptions
    },
    {
        field: "new",
        headerName: "New Value",
        headerAlign: "center",
        align: "center",
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                    {params.colDef.headerName!}
                </Typography>
            );
        },
        renderCell: (params: GridRenderCellParams) => {
            if ((params.row.fieldName as string).includes("Date")) {
                return (
                    <Typography>
                        { params.value === null ? "n/a" : formatDateHyphen(new Date(params.value)) }
                    </Typography>
                )
            }

            return (
                <Typography>
                    {((params.value === null) || (params.value === "")) ? "n/a" : params.value}
                </Typography>
            )
        },
        ...defaultColumnOptions
    },
]
export const ViewChangesDatagrid: FunctionComponent<{ rows: ChangeRow[] }> = ({ rows }) => {
    return (
        <CustomDataGrid
            width={600}
            height={400}
            columns={columns}
            sortingOrder={["asc", "desc"]}
            rows={rows}
            hideFooterPagination
        />
    )
}